import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import DatePicker, { registerLocale } from "react-datepicker";
import withReactContent from "sweetalert2-react-content";
import swal from "sweetalert2";
import moment from "moment";
import { setHours, setMinutes, toDate } from 'date-fns';
import queryString from "query-string";
import cn from "classnames";
import {
  BtnBold,
  BtnBulletList,
  BtnClearFormatting,
  BtnLink,
  BtnItalic,
  BtnNumberedList,
  BtnRedo,
  BtnStrikeThrough,
  BtnStyles,
  BtnUnderline,
  BtnUndo,
  HtmlButton,
  Separator,
  Editor,
  EditorProvider,
  Toolbar,
  createButton,
} from 'react-simple-wysiwyg';

import { salesAvailabilityOptions } from "../../../../../constants/salesAvailabilityOptions";
import { currencies } from "../../../../../constants/currencies";
import { getTimeZoneAsyncFunc } from "../../../../../helpers/getTimeZoneAsync";
import { getPdfTemplatesAsyncFunc } from "../../../../../helpers/getPdfTemplatesAsyncFunc";
import ROUTES from "../../../../../constants/routes";
import { makeElementsReadonly } from "../../../../../helpers/html";
import Page404 from "../../../../../components/Page404/Page404"
import CheckBox from "../../../../../components/UI/Checkbox/CheckBox";
import { Counter } from "../../../../../components/Counter/Counter";
import Icon from "../../../../../components/UI/Icon/Icon";
import { cancelEvent, cloneEvent, deleteEvent,
  getEvent,
  getEventMaps,
  resetEventsError,
  updateEvent,
  updateHeaderImage,
  updateScannedTickets,
} from "../../../../../store/actions/eventsActions";
import { getTemplates } from "../../../../../store/actions/canvasActions";
import Dropzone from "../../../../Upload/Dropzone/Dropzone";

import "./EventInfo.sass";
import { Tooltip } from "../../../../../components/UI/Tooltip/Tooltip";
import enGB from 'date-fns/locale/en-GB';
import { CloneEventModal } from "./CloneEventModal";

const MySwal = withReactContent(swal);

class EventInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      currentEvent: {
        eventEmails: {
          emailTicketTemplateId: 0,
          emailOfferTemplateId: 0,
          emailGuestTemplateId: 0,
          emailErrorTemplateId: 0,
          emailInvoiceTemplateId: 0,
        },
        needUpdateWallets: true,
        timeZone: "",
        currency: {},
        isHidden: false,
      },
      isDisabled: true,
      isFound: true,
      scannedTicketsStartDate: null,
      scannedTicketsEndDate: null,
      qrCodeVisibilityHours: 0,
      timeZoneOption: {},
      currentPdfTemplate: {
        value: null,
        label: "",
      },
      isHiddenMode: queryString.parse(this.props.location.search).action === "hide",
      imageType: "desktop",
      maps: [],
      selectedMap: null,
    };
  };

  static getDerivedStateFromProps(props, state) {
    if (
      (props.currentEvent.id
        && props.currentEvent.id !== state.currentEvent.id
      ) || !state.currentPdfTemplate
    ) {
      const currentEvent = {
        ...props.currentEvent,
        salesAvailability: salesAvailabilityOptions.find(
          (o) => o.value === props.currentEvent.salesAvailability
        ),
        currency: currencies.find(
          (option) => option.value === props.currentEvent.currency
        ),
        startDate: props.currentEvent.startDate,
        endDate: props.currentEvent.endDate,
        extraFeeRate: props.currentEvent.extraFeeRate * 100,
        ticketsSoldText: props.currentEvent.ticketsSoldText || "Tickets sold out",
        salesNotAvailableText: props.currentEvent.salesNotAvailableText || "Sales not available",
      };
      
      return {
        currentEvent,
        timeZoneOption: {
          value: props.currentEvent.timeZone,
          label: props.currentEvent.timeZone,
        },
        currentPdfTemplate: props.pdfTemplates.find(
          ({ value }) => value === props.currentEvent.pdfTemplateId,
        ),
      };
    };
    return null;
  };

  handleUploadFile = (files) => {
    const type = this.state.imageType === "mobile" ? 2 : 1;

    this.props.updateHeaderImage(
      this.props.user.token,
      this.state.currentEvent.id,
      files,
      type
    );
  };

  handleChangeEventField = (name, value) => {
    const { ...currentEvent } = this.state.currentEvent;
    currentEvent[name] = value;

    if (this.props.error) {
      this.props.resetEventsError();
    };

    if (name === "fixedFeeRate" || name === "extraFeeRate") {
      if (value === "-") {
        this.setState({
          currentEvent,
          isDisabled: true,
        });
      } else {
        this.setState({
          currentEvent,
          isDisabled: false,
        });
      };

      return;
    };

    if ((value === "" || value === "-") && name !== "ticketsSoldText" && name !== "salesNotAvailableText") {
      this.setState({
        currentEvent,
        isDisabled: true,
      });
    } else {
      this.setState({
        currentEvent,
        isDisabled: false,
      });
    };
  };

  changeEventInfo = (event) => {
    let { name, value } = event.target;

    if (name === "fixedFeeRate" || name === "extraFeeRate") {
      if (value[0] === "-") {
        value = "-" + value.replace(/[^\d.]/g, '');
      } else {
        value = value.replace(/[^\d.]/g, '');
      };

      if (name === "extraFeeRate" && (+value > 100 || +value < -100)) {
        return;
      }
    };

    this.handleChangeEventField(name, value);
  };

  inputTimeZoneChangeHandle = (value) => {
    this.setState({ timeZoneOption: value, isDisabled: false })
  };

  onTimeZoneMenuOpen = () => {
    setTimeout(()=>{
      const selectedEl = document.getElementsByClassName("custom-select__option--is-selected")[0];
      if(selectedEl){
        selectedEl.scrollIntoView({block: 'nearest',});
      }
    });
  };

  handleChangeDate = (name, value) => {
    const { ...currentEvent } = this.state.currentEvent;

    currentEvent[name] = value;

    this.setState({
      currentEvent,
      isDisabled: false,
    });
  };

  handleChangeCurrency = (value) => {
    const { ...currentEvent } = this.state.currentEvent;

    currentEvent.currency = value;

    this.setState({
      currentEvent,
      isDisabled: false,
    });
  };

  handleChangeSalesAvailability = (value) => {
    const { ...currentEvent } = this.state.currentEvent;

    currentEvent.salesAvailability = value;

    this.setState({
      currentEvent,
      isDisabled: false,
    });
  };

  handleChangeActivationTime = (value) => {
    const { ...currentEvent } = this.state.currentEvent;

    currentEvent.activationTime = value;

    this.setState({
      currentEvent,
      isDisabled: false,
    });
  };

  handleChangeSalesEndTime = (value) => {
    const { ...currentEvent } = this.state.currentEvent;

    currentEvent.salesEndTime = value;

    this.setState({
      currentEvent,
      isDisabled: false,
    });
  };

  handleChangePdfTemplate = (value) => {
    this.setState({
      currentPdfTemplate: value,
      isDisabled: false,
    });
  };

  handleChangeImageType = (e) => {
    this.setState({ imageType: e.target.value })
  };

  handleChangeMap = (value) => {
    this.setState({
      selectedMap: value,
      isDisabled: false,
    });
  };

  handleChangeDescription = (e) => {
    this.handleChangeEventField('description', e.target.value);
  }

  deleteEvent = () => {
    const { currentEvent } = this.state;
    const { deleteEvent } = this.props;

    MySwal.fire({
      title: "Are you sure that you want to delete this event?",
      text: "It's impossible to take step back then",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      showConfirmButton: true,
      confirmButtonText: "Delete",
      reverseButtons: true,
      customClass: "warning-modal",
    }).then((result) => {
      if (result.value) {
        deleteEvent(this.props.user.token, currentEvent.id).then((result) => {
          if (result && result.isSuccess) {
            this.props.history.push(ROUTES.EVENTS);
          }
        });
      }
    });
  };

  cancelEvent = () => {
    const { currentEvent } = this.state;
    const { cancelEvent } = this.props;

    MySwal.fire({
      title: "Are you sure that you want to cancel this event?",
      text: "It's impossible to take step back then",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      showConfirmButton: true,
      confirmButtonText: "Confirm",
      reverseButtons: true,
      customClass: "warning-modal",
    }).then((result) => {
      if (result.value) {
        cancelEvent(this.props.user.token, currentEvent.id).then((result) => {
          if (result && result.isSuccess) {
            this.props.history.push(ROUTES.EVENTS);
          }
        });
      }
    });
  };

  cloneEvent = () => {
    const { currentEvent } = this.state;
    const { cloneEvent } = this.props;

    MySwal.fire({
      html: <CloneEventModal
        cloneEvent={(data) => {
          cloneEvent(this.props.user.token, currentEvent.id, data)
            .then(res => {
              if (res) {
                MySwal.close();
              }
            })
        }}
        eventData={currentEvent}
      />,
      showConfirmButton: false,
      allowOutsideClick: false,
      reverseButtons: true,
    });
  };

  updateEvent = () => {
    const { currentEvent, selectedMap } = this.state;

    const updateSalesAvailabilityData = {
      salesAvailability: currentEvent.salesAvailability.value,
      activationTime: moment(currentEvent.activationTime)
        .utcOffset(0, true)
        .format(),
      salesEndTime: moment(currentEvent.salesEndTime)
        .utcOffset(0, true)
        .format(),
    };

    const data = {
      ...updateSalesAvailabilityData,
      slug: currentEvent.slug,
      isDeactivate: false,
      name: currentEvent.name,
      startDate: moment(currentEvent.startDate).utcOffset(0, true).format(),
      endDate: moment(currentEvent.endDate).utcOffset(0, true).format(),
      currency: currentEvent.currency.value,
      fixedFeeRate: +currentEvent.fixedFeeRate || 0,
      extraFeeRate: (+currentEvent.extraFeeRate / 100) || 0,
      administrativeFeePaidByCustomer: currentEvent.administrativeFeePaidByCustomer,
      processingFeePaidByCustomer: currentEvent.processingFeePaidByCustomer,
      isCheckingCovid: currentEvent.isCheckingCovid,
      place: currentEvent.place,
      prefixLabel: currentEvent.prefixLabel,
      isAvailableForEarlySells: currentEvent.isAvailableForEarlySells,
      maxSeatsToSelectPerTransaction:
        currentEvent.maxSeatsToSelectPerTransaction,
      qrCodeVisibilityHours: currentEvent.qrCodeVisibilityHours,
      needUpdateWallets: currentEvent.needUpdateWallets,
      timeZone: this.state.timeZoneOption.value,
      pdfTemplateId: this.state.currentPdfTemplate.value,
      isHidden: currentEvent.isHidden,
      hideForUpcoming: currentEvent.hideForUpcoming,
      seatsIoMapId: selectedMap ? selectedMap.value : null,
      description: currentEvent.description || null,
      ticketsSoldText: currentEvent.ticketsSoldText,
      salesNotAvailableText: currentEvent.salesNotAvailableText,
    };

    if (data.name.length < 2 || data.name.length > 500) {
      MySwal.fire({
        title: "Error!",
        text: "The field Name must be a string with a minimum length of 2 and a maximum length of 500.",
        showConfirmButton: true,
        confirmButtonText: "Ok",
        type: "error",
        timer: 3000,
      });
    } else if (data.slug.length < 2 || data.slug.length > 30) {
      MySwal.fire({
        title: "Error!",
        text: "The field slug must be a string with a minimum length of 2 and a maximum length of 30.",
        showConfirmButton: true,
        confirmButtonText: "Ok",
        type: "error",
        timer: 3000,
      });
    }
    else {
      this.updateEventWithData(data);
    }
  };

  updateEventWithData(data) {
    const { updateEvent, user } = this.props;
    const eventId = this.state.currentEvent.id;
    const action = queryString.parse(this.props.location.search).action;

    updateEvent(user.token, eventId, data)
      .then(() => this.props.getEvent(eventId, user.token, action));
  }

  componentDidMount() {
    makeElementsReadonly("react-datepicker__input-container");

    const { match, getTemplates } = this.props;
    const eventId = match.params.id;

    getTemplates(eventId, false);
    registerLocale('en-GB', enGB);
    this.props.getEventMaps().then(res => {
      const maps = !!res ? res.map(m => ({ value: m.id, label: m.name })) : [];

      this.setState({ maps })
    })
  };

  render() {
    if (!this.state.isFound) {
      return <Page404 />;
    };


    const customSelectStyles = {
      control: (base) => ({
        ...base,
        height: "46px",
        "min-height": "46px",
        cursor: "pointer",
      }),
    };

    const {
      currentEvent,
      timeZoneOption,
      currentPdfTemplate,
      isHiddenMode,
      imageType,
      maps,
      selectedMap,
    } = this.state;

    const { startDate, endDate, activationTime, salesEndTime, seasonName } = currentEvent;

    const { currentEvent: { headerImageUrl, headerMobileImageUrl }, match} = this.props;
    const classes = [];

    if (
      currentEvent.ticketTemplates &&
      currentEvent.ticketTemplates.length > 6
    ) {
      classes.push("scroll");
    };

    const BtnFontColor = createButton('Color', '', (val) => {
      document.execCommand('foreColor', false, prompt('HEX Color', '') || undefined);
    });

    return (
      <div className="new-event__info info">
        <div className={cn("add-event__block info__header-image", {
          "info__header-image--mobile": imageType === "mobile",
        })}>
          <label>Header image </label>
          <div className="info__radio-wrapper">
            <label className="radiobutton">
              <input
                className="radiobutton__input"
                name="headerImage"
                type="radio"
                value="desktop"
                onChange={this.handleChangeImageType}
                checked={imageType === "desktop"}
              />
              <span>Desktop</span>
            </label>
            <label className="radiobutton">
              <input
                className="radiobutton__input"
                name="headerImage"
                type="radio"
                value="mobile"
                onChange={this.handleChangeImageType}
                checked={imageType === "mobile"}
              />
              <span>Mobile</span>
            </label>

            <label className="info__img-sizes">{imageType === "desktop" ? "(recommended size: 1300 x 520 px)" : "(recommended size: 380 x 510 px)"}</label>
          </div>

          <img src={headerMobileImageUrl} style={{ display: 'none'}} alt="" />

          {imageType === "mobile" ? (
            <Dropzone
              imgUrl={headerMobileImageUrl}
              onFilesAdded={this.handleUploadFile}
              onButtonEnable={() => { }}
              unsupportedFileFormatHandle={() => { }}
              onlyOneFileErrorHandle={() => { }}
            />
          ) : (
            <Dropzone
              imgUrl={headerImageUrl}
              onFilesAdded={this.handleUploadFile}
              onButtonEnable={() => { }}
              unsupportedFileFormatHandle={() => { }}
              onlyOneFileErrorHandle={() => { }}
            />
          )}
        </div>

        <div className="add-event__row">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Event name</label>
              <input
                type="text"
                name="name"
                value={currentEvent.name}
                placeholder="Enter event name"
                minLength="3"
                maxLength="500"
                onChange={this.changeEventInfo}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Venue</label>
              <input
                type="text"
                name="place"
                minLength="3"
                maxLength="500"
                placeholder="Enter venue"
                value={currentEvent.place}
                onChange={this.changeEventInfo}
              />
            </div>
          </div>

          {currentEvent.seasonName && (
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Season</label>
                <span className="add-event__block__count">
                  {currentEvent.seasonName}
                </span>
              </div>
            </div>
          )}
        </div>

        <div className="add-event__row">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Start</label>
              <DatePicker
                selected={this.state.currentEvent.startDate}
                onChange={(value) => this.handleChangeDate("startDate", value)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="d MMM yyyy h:mm a"
                timeCaption="time"
                locale="en-GB"
                maxDate={endDate ? toDate(endDate) : null}
                minTime={setHours(setMinutes(new Date(), 0), 0)}
                maxTime={startDate && endDate && moment(startDate).dayOfYear() ===  moment(endDate).dayOfYear() && moment(startDate).year() ===  moment(endDate).year()
                  ? setHours(setMinutes(new Date(), moment(startDate).minute()), moment(startDate).hour())
                  : setHours(setMinutes(new Date(), 45), 23)
                }
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>End</label>
              <DatePicker
                selected={this.state.currentEvent.endDate}
                onChange={(value) => this.handleChangeDate("endDate", value)}
                showTimeSelect
                timeFormat="HH:mm"
                timeIntervals={15}
                dateFormat="d MMM yyyy h:mm a"
                timeCaption="time"
                locale="en-GB"
                minDate={startDate ? toDate(startDate) : null}
                minTime={startDate && endDate && moment(startDate).dayOfYear() ===  moment(endDate).dayOfYear() && moment(startDate).year() ===  moment(endDate).year()
                  ? setHours(setMinutes(new Date(), moment(startDate).minute()), moment(startDate).hour())
                  : setHours(setMinutes(new Date(), 0), 0)
                }
                maxTime={setHours(setMinutes(new Date(), 45), 23)}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Time Zone</label>

              <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={getTimeZoneAsyncFunc()}
                value={timeZoneOption}
                onChange={this.inputTimeZoneChangeHandle}
                classNamePrefix='custom-select'
                className='custom-select'
                onMenuOpen={this.onTimeZoneMenuOpen}
              />
            </div>
          </div>
        </div>

        <div className="add-event__row">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Currency</label>

              <Select
                options={currencies}
                name="currency"
                classNamePrefix="custom-select"
                value={currentEvent.currency}
                defaultValue={currentEvent.currency}
                onChange={(value) => this.handleChangeCurrency(value)}
                className="custom-select"
                styles={customSelectStyles}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary: "#6071B5",
                    primary25: "#F2F4FE",
                    primary50: "#F2F4FE",
                    primary75: "#F2F4FE",
                  },
                })}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>
                {<Link style={{ margin: '0' }}
                  target='_blank'
                  to={ROUTES.SELLING.replace(':slug', currentEvent.slug).replace(':id', '')}>
                  Slug
                </Link>
                }
                <Tooltip
                  className="add-event__tooltip"
                  description="The unique string will be part of the 'Slug' page's web address."
                >
                  <Icon name="info" />
                </Tooltip>
              </label>
              <input
                type="text"
                name="slug"
                value={currentEvent.slug}
                placeholder="Enter slug"
                minLength="3"
                maxLength="500"
                onChange={this.changeEventInfo}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>
                PDF Template

                <Tooltip
                  className="add-event__tooltip add-event__tooltip--color-grey"
                  description="Selected PDF Template will be set by default for a new created ticket."
                >
                  <Icon name="info" />
                </Tooltip>
              </label>

              <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={getPdfTemplatesAsyncFunc(match.params.id, false)}
                value={currentPdfTemplate}
                onChange={this.handleChangePdfTemplate}
                classNamePrefix='custom-select'
                className='custom-select'
              />
            </div>
          </div>
        </div>

        <div className="add-event__row add-event__row--width-divider">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Category</label>

              <input
                type="text"
                name="prefixLabel"
                minLength="3"
                maxLength="500"
                placeholder="Enter event category"
                value={currentEvent.prefixLabel}
                onChange={this.changeEventInfo}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block add-event__block--checkbox">
              <CheckBox
                name="hideForUpcoming"
                id="hideForUpcoming"
                checked={currentEvent.hideForUpcoming}
                onChange={(e) => {
                  this.handleChangeEventField(
                    "hideForUpcoming",
                    e.target.checked
                  )
                }}
              >
                Hide from agenda
              </CheckBox>
            </div>
          </div>
        </div>

        <div className="add-event__row">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Sales availability</label>

              <Select
                options={salesAvailabilityOptions}
                name="salesAvailability"
                classNamePrefix="custom-select"
                value={currentEvent.salesAvailability}
                defaultValue={currentEvent.salesAvailability}
                onChange={this.handleChangeSalesAvailability}
                className="custom-select"
                styles={customSelectStyles}
                theme={(theme) => ({
                  ...theme,
                  colors: {
                    ...theme.colors,
                    primary: "#6071B5",
                    primary25: "#F2F4FE",
                    primary50: "#F2F4FE",
                    primary75: "#F2F4FE",
                  },
                })}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Sales start time</label>

              <DatePicker
                selected={currentEvent.activationTime}
                onChange={this.handleChangeActivationTime}
                timeFormat="HH:mm"
                showTimeSelect
                timeIntervals={15}
                dateFormat="d MMM yyyy h:mm a"
                timeCaption="time"
                placeholderText="Select activation time"
                locale="en-GB"
                maxDate={salesEndTime ? toDate(salesEndTime) : null}
                minTime={setHours(setMinutes(new Date(), 0), 0)}
                maxTime={activationTime && salesEndTime && moment(activationTime).dayOfYear() ===  moment(salesEndTime).dayOfYear() && moment(activationTime).year() ===  moment(salesEndTime).year()
                  ? setHours(setMinutes(new Date(), moment(activationTime).minute()), moment(activationTime).hour())
                  : setHours(setMinutes(new Date(), 45), 23)
                }
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Sales end time</label>

              <DatePicker
                selected={currentEvent.salesEndTime}
                onChange={this.handleChangeSalesEndTime}
                timeFormat="HH:mm"
                showTimeSelect
                timeIntervals={15}
                dateFormat="d MMM yyyy h:mm a"
                timeCaption="time"
                placeholderText="Select sales end time"
                minDate={activationTime ? toDate(activationTime) : null}
                minTime={activationTime && salesEndTime && moment(activationTime).dayOfYear() ===  moment(salesEndTime).dayOfYear() && moment(activationTime).year() ===  moment(salesEndTime).year()
                  ? setHours(setMinutes(new Date(), moment(activationTime).minute()), moment(activationTime).hour())
                  : setHours(setMinutes(new Date(), 0), 0)
                }
                maxTime={setHours(setMinutes(new Date(), 45), 23)}
                locale="en-GB"
              />
            </div>
          </div>
        </div>

        <div className="add-event__row">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>
                Map

                <Tooltip
                  className="add-event__tooltip add-event__tooltip--color-grey"
                  description="The map can be added once and can't be edited later."
                >
                  <Icon name="info" />
                </Tooltip>
              </label>

              {!!this.props.currentEvent.mapId ? (
                <span className="add-event__block__count">
                  {this.props.currentEvent.mapName}
                </span>
              ) : (
                <Select
                  isClearable
                  options={maps}
                  classNamePrefix="custom-select"
                  value={selectedMap}
                  onChange={(value) => {
                    this.handleChangeMap(value);
                  }}
                  className="custom-select"
                  styles={customSelectStyles}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary: "#6071B5",
                      primary25: "#F2F4FE",
                      primary50: "#F2F4FE",
                      primary75: "#F2F4FE",
                    },
                  })}
                  placeholder="Select map"
                />
              )}
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <Counter
                label={<>
                  Number of tickets in one transaction
                  <Tooltip
                    className="add-event__tooltip"
                    description="The number will regulate the maximum number of tickets per transaction."
                  >
                    <Icon name="info" />
                  </Tooltip>
                </>}
                value={currentEvent.maxSeatsToSelectPerTransaction}
                onValueChange={(value) =>
                  this.handleChangeEventField(
                    "maxSeatsToSelectPerTransaction",
                    value
                  )
                }
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <Counter
                min="0"
                label={<>
                  {currentEvent.qrCodeVisibilityHours > 0 ? `QR-code will be visible in ${currentEvent.qrCodeVisibilityHours} hours before event` : "QR-code will be visible any time"}
                  <Tooltip
                    className="add-event__tooltip"
                    description="Selected number will regulate visibility of QR-codes in Apple and Google wallets."
                  >
                    <Icon name="info" />
                  </Tooltip>
                </>}
                value={currentEvent.qrCodeVisibilityHours}
                onValueChange={(value) =>
                  this.handleChangeEventField(
                    "qrCodeVisibilityHours",
                    value
                  )
                }
              />
            </div>
          </div>
        </div>

        <div className="add-event__row add-event__row--width-divider">
          <div className="add-event__column">
            <div className="add-event__block">
              <label>Fixed fee rate, {currentEvent.currency.label}</label>
              <input
                type="text"
                name="fixedFeeRate"
                value={currentEvent.fixedFeeRate}
                placeholder="Enter fixed fee rate"
                minLength="3"
                maxLength="500"
                onChange={this.changeEventInfo}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block">
              <label>Extra fee rate, %</label>
              <input
                type="text"
                name="extraFeeRate"
                value={currentEvent.extraFeeRate}
                placeholder="Enter extra fee rate"
                minLength="3"
                maxLength="500"
                onChange={this.changeEventInfo}
              />
            </div>
          </div>
        </div>

        <div className="add-event__row add-event__row--width-divider">
          <div className="add-event__column">
            <div className="add-event__block add-event__block--fullWidth">
              <label>Tickets sold text</label>
              <input
                type="text"
                name="ticketsSoldText"
                value={currentEvent.ticketsSoldText}
                placeholder="Enter tickets sold text"
                onChange={this.changeEventInfo}
              />
            </div>
          </div>

          <div className="add-event__column">
            <div className="add-event__block add-event__block--fullWidth">
              <label>Sales not available text</label>
              <input
                type="text"
                name="salesNotAvailableText"
                value={currentEvent.salesNotAvailableText}
                placeholder="Enter sales not available text"
                onChange={this.changeEventInfo}
              />
            </div>
          </div>
        </div>

        <div className="add-event__block add-event__block--fullWidth">
          <div className="add-event__editor">
            <label>Description</label>
            <EditorProvider>
              <Editor
                value={currentEvent.description}
                onChange={this.handleChangeDescription}
              >
              <Toolbar>
                <BtnUndo />
                <BtnRedo />
                <Separator />
                <BtnBold />
                <BtnItalic />
                <BtnUnderline />
                <BtnStrikeThrough />
                <BtnFontColor />
                <Separator />
                <BtnNumberedList />
                <BtnBulletList />
                <Separator />
                <BtnLink />
                <BtnClearFormatting />
                <HtmlButton />
                <Separator />
                <BtnStyles />
              </Toolbar>
              </Editor>
            </EditorProvider>
          </div>
        </div>

        <div className="page-footer">
          <div className="page-footer__checkboxes">
            {isHiddenMode && (
              <div className="page-footer__hidden-checkbox">
                <CheckBox
                  name="isHidden"
                  id="isHidden"
                  checked={currentEvent.isHidden}
                  onChange={(e) => {
                    this.handleChangeEventField(
                      "isHidden",
                      e.target.checked
                    )
                  }}
                >
                  Hide event
                </CheckBox>
              </div>
            )}

              <CheckBox
                name="memberSellAvailiability"
                id="memberSellAvailiability"
                checked={currentEvent.isAvailableForEarlySells}
                onChange={() => {
                  this.handleChangeEventField(
                    "isAvailableForEarlySells",
                    !currentEvent.isAvailableForEarlySells
                  )
                }}
              >
                Members can buy daily tickets beforehand
                <Tooltip
                  className="add-event__tooltip"
                  description="Active checkbox allow members to buy tickets beforehand for daily events from their account page."
                  relevantY={-50}
                >
                  <Icon name="info" />
                </Tooltip>
              </CheckBox>

            <CheckBox
              name="isNeedBookSeats"
              id="is-need-book-seats"
              checked={currentEvent.needUpdateWallets}
              onChange={(e) => {
                this.handleChangeEventField(
                  "needUpdateWallets",
                  e.target.checked
                )
              }
              }
            >
              Update wallets
              <Tooltip
                className="add-event__tooltip"
                description="Active checkbox will instantly update all active Apple and Google wallets."
                relevantY={-50}
              >
                <Icon name="info" />
              </Tooltip>
            </CheckBox>
          </div>

          <div className="page-footer__buttons-block">
            {!seasonName && (
              <button
                className="btn-primary"
                type="button"
                onClick={this.cloneEvent}
              >
                <span>Clone</span>
              </button>
            )}

            <button
              className="btn-primary"
              type="button"
              onClick={this.cancelEvent}
            >
              <span>Cancel</span>
            </button>

            <button
              className="btn-red-outline"
              type="button"
              onClick={this.deleteEvent}
            >
              <span>Delete</span>
            </button>

            <button
              type="button"
              className="btn-primary btn-primary--save"
              onClick={this.updateEvent}
              disabled={this.state.isDisabled}
            >
              <span>Save</span>
            </button>
          </div>
        </div>
      </div>
    );
  }
};

const mapStateToProps = ({
  auth: { user },
  events: { currentEvent, loading, error },
  canvas: { templates, isTemplatesLoading },
}) => ({ user, currentEvent, loading, error, pdfTemplates: templates, isTemplatesLoading });

const mapDispatchToProps = (dispatch) => ({
  updateHeaderImage: (token, eventId, files, imageType) =>
    dispatch(updateHeaderImage(token, eventId, files, imageType)),
  updateScannedTickets: (eventId, token, start, end) =>
    dispatch(updateScannedTickets(eventId, token, start, end)),
  updateEvent: (userToken, eventId, data) =>
    dispatch(updateEvent(userToken, eventId, data)),
  deleteEvent: (userToken, eventId) =>
    dispatch(deleteEvent(userToken, eventId)),
  cancelEvent: (userToken, eventId) =>
    dispatch(cancelEvent(userToken, eventId)),
  cloneEvent: (userToken, eventId, data) =>
    dispatch(cloneEvent(userToken, eventId, data)),
  resetEventsError: () => dispatch(resetEventsError()),
  getEvent: (eventId, token, action) => dispatch(getEvent(eventId, token, action)),
  getTemplates: (eventId, withEmptyOption) => dispatch(getTemplates(eventId, withEmptyOption)),
  getEventMaps: () => dispatch(getEventMaps()),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventInfo);